import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import EmployerTestimonialCard from '../../assets/cards/EmployerTestimonialCard'

export default function EmployerTestimonial() {
  return (
    <>
    <Box>
        <Box>
            <Typography     sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "30px",
              lineHeight: "36px",
              color: "#000000",
              my:3
            }}>Testimonial</Typography>
            <Box>
            <Grid container spacing={2} my={6}>
            <Grid item md={4}>
            <EmployerTestimonialCard/>
            </Grid>
            <Grid item md={4}>
            <EmployerTestimonialCard/>
            </Grid>
            <Grid item md={4}>
            <EmployerTestimonialCard/>
            </Grid>
         
          </Grid>
            </Box>
        </Box>
    </Box>
    </>
  )
}
